<template>
  <div class="header">
    <nav class="nav">
      <ul>
        <li class="on">
          <router-link to="/">
            {{ $t('nav.home') }}
          </router-link>
        </li>
        <li v-for="(item,index) in categoryList.slice(0, 6)" :key="index" @click="jumpCategory(item)">
          {{item.classifyName}}
        </li>
      </ul>
    </nav>
    <div class="search">
      <div class="searchSelect">
        <el-dropdown @command="searchCommand" trigger="click">
              <span class="el-dropdown-link">{{searchVal}}
                <i class="el-icon-arrow-down cur-poi el-icon--right"></i>
              </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="$t('search.productName')">{{ $t('search.productName') }}</el-dropdown-item>
            <el-dropdown-item :command="$t('search.shop')">{{ $t('search.shop') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="searchRight">
        <input type="text"
          v-model="keyword"
          @keyup.enter="searchPro"
          :placeholder="$t('search.placeholder')"
        >
      </div>
      <span class="btn cur-poi" @click="searchPro">
        <i class="icon el-icon-search"></i>
      </span>
    </div>
  </div>
</template>

<script>
import {
  getCategory
} from '@/api/nav.js'
import { autoLogin } from '@/api/login.js'
import { getUserInfo } from '@/api/user/user.js'
import Cookie from 'js-cookie'
import store from '@/store/index.js'
import { mapMutations } from 'vuex'
import i18n from '@/config/lang'
export default {
  name: 'homHeader',
  i18n,
  data () {
    return {
      searchVal: this.$t('search.productName'),
      keyword: '',
      categoryList: []
    }
  },
  mounted () {
    this.getCategoryData()
    this.checkAutoLogin()
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ'
    }),
    searchCommand (command) {
      this.searchVal = command
    },
    // 查找
    searchPro () {
      this.setSearchObj({
        keyword: this.keyword,
        searchVal: this.searchVal
      })
      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search'
        })
      }
    },
    async getCategoryData () {
      const response = await getCategory()
      const res = response.data
      if (res.code === '200') {
        this.categoryList = res.data
      }
    },
    // 跳转到类别主页
    jumpCategory (item) {
      this.$router.push({
        name: 'category',
        query: {
          classifyData: JSON.stringify(item)
        }
      })
    },
    // 检查是否需要自动登录
    async checkAutoLogin () {
      const query = this.$route.query
      const channel = query.channeld
      const subChannel = query.subChannel
      const unionCode = query.unionCode
      console.log('自动登录参数', channel, subChannel, unionCode)
      // 检查是否存在自动登录参数
      if (channel && subChannel && unionCode) {
        try {
          // 获取shopId参数（可选）

          // 调用自动登录接口
          const response = await autoLogin({
            channel: channel,
            subChannel: subChannel,
            unionCode: unionCode,
            shopId: 17
          })

          const res = response.data
          if (res.code === '200') {
            // 登录成功，设置token
            Cookie.set('token', res.data.token, { expires: 1 })

            // 获取用户信息
            await this.getUserInfoData()

            // 显示登录成功消息
            this.$message({
              message: this.$t('user.loginSuccess'),
              type: 'success',
              customClass: 'messageZindex'
            })

            // 更新登录状态
            store.commit('IS_LOGIN', true)

            // 清除URL参数，避免重复登录
            const newQuery = { ...query }
            delete newQuery.channeld
            delete newQuery.subChannel
            delete newQuery.unionCode
            delete newQuery.shopId

            this.$router.replace({
              query: newQuery
            })
          } else {
            this.$message({
              message: res.message,
              type: 'warning',
              customClass: 'messageZindex'
            })
          }
        } catch (error) {
          console.error('自动登录失败:', error)
          this.$message({
            message: this.$t('common.systemError'),
            type: 'error',
            customClass: 'messageZindex'
          })
        }
      }
    },
    // 获取用户信息
    async getUserInfoData () {
      try {
        const response = await getUserInfo()
        const res = response.data
        if (res.code === '200') {
          store.commit('SET_USERINFO', res.data)
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
$lightBlack: #666666;
$navSearchHeight: 39px;
.header{
  height: 80px;
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  .nav{
    float: left;
    padding-top: 30px;
    ul{
      width: 760px;
      display: flex;
      justify-content: space-between;
    }
    li{
      font-size: 16px;
      line-height: 21px;
      padding-bottom: 24px;
      color: #333;
      cursor: pointer;
      border-bottom: 3px solid #fff;
      &.on,&:hover{
        color: #C5AA7B;
        border-color: #C5AA7B;
      }
    }
  }
  .search{
    width: 394px;
    height: 39px;
    border: 2px solid #F3F4F5;
    float: right;
    // margin-top: 21px;
    display: flex;
    .searchSelect{
      width: 82px;
      height: 30px;
      margin-top: 2px;
      border-right: 1px solid #CCCCCC;
      text-align: center;
      line-height: 30px;
      .el-dropdown{
        color: #C5AA7B;
      }
    }
    .searchRight{
      flex: 1;
      input{
        padding-left: 15px;
        font-size: 14px;
        color: #333;
        line-height: 35px;
      }
    }
    .btn{
      font-size: 20px;
      line-height: 35px;
      padding-right: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/homHeader.vue